import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function SystemBoot({ onComplete }) {
  const [step, setStep] = useState(0);
  
  useEffect(() => {
    const steps = [
      setTimeout(() => setStep(1), 500),  // "Initializing..."
      setTimeout(() => setStep(2), 1200), // "Modules Loaded"
      setTimeout(() => setStep(3), 2000), // "System Optimal"
      setTimeout(() => onComplete(), 2500) // Fade out
    ];
    return () => steps.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[100] bg-[var(--bg-void)] flex flex-col items-center justify-center font-mono text-xs transition-colors duration-700">
      {/* Loading Bar */}
      <div className="w-64 h-1 bg-[var(--text-muted)]/10 rounded-full overflow-hidden mb-4">
        <motion.div 
          className="h-full bg-[var(--nily-teal)]"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 2.2, ease: "easeInOut" }}
        />
      </div>

      {/* Status Text */}
      <div className="h-6 flex items-center justify-center text-[var(--nily-teal)]">
        <AnimatePresence mode="wait">
          {step === 0 && <motion.span key="1" initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}>INITIALIZING NEUROVA CORE...</motion.span>}
          {step === 1 && <motion.span key="2" initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}>LOADING PERSONA ENGINE...</motion.span>}
          {step === 2 && <motion.span key="3" initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}>ESTABLISHING SECURE LINK...</motion.span>}
          {step === 3 && <motion.span key="4" initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} className="text-[var(--text-primary)]">SYSTEM OPTIMAL.</motion.span>}
        </AnimatePresence>
      </div>
    </div>
  );
}
